export const recede = function() {
  Turbo.cache.clear()
  history.go(-1)
}